import { render, staticRenderFns } from "./ManagePhone.vue?vue&type=template&id=1263bdfe&scoped=true&"
import script from "./ManagePhone.vue?vue&type=script&lang=js&"
export * from "./ManagePhone.vue?vue&type=script&lang=js&"
import style0 from "./ManagePhone.vue?vue&type=style&index=0&id=1263bdfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1263bdfe",
  null
  
)

export default component.exports